import React, { useEffect, useState } from 'react';
import styles from './styles.scoped.css';
import Button from '../../components/elements/Button/Button';
import ButtonFileInput from '../../components/elements/ButtonFileInput/ButtonFileInput';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ButtonLink from '../../components/elements/ButtonLink';

export function FormRegistrasiBulk({
  change = () => {},
  handleSubmit = () => {},
}) {
  const [error, setError] = useState({});
  const [file, setFile] = useState({});

  const { isLoadingSubmitRegistration, messageSubmitRegistration } =
    useSelector((s) => s.merchantRegistrations);

  const clearErrors = () => {
    setError({});
  };

  let bodyFormData = new FormData();

  const handleRemoveFormData = () => {
    setFile({});
  };

  const handleChangeFile = (name, val) => {
    const modPayload = { file: val };
    Object.keys(modPayload).forEach((val) => {
      bodyFormData.append(name, modPayload[val]);
    });
    setFile(bodyFormData);
  };

  useEffect(() => {
    change('file', file);
  }, [file]);

  const handleIsValid = () => {
    if (
      file instanceof FormData &&
      Object.keys(error).length === 0 &&
      isLoadingSubmitRegistration !== true
    ) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (
      messageSubmitRegistration?.includes(' is required') &&
      !isLoadingSubmitRegistration
    ) {
      setError({ file: { message: 'Belum memasukkan file' } });
    }
  }, [isLoadingSubmitRegistration]);
  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className={styles['top-content-upload-reg-container']}>
          <div className={styles['left-content-upload-reg']}>
            <h4>
              Pilih file dengan format .xlsx untuk registrasi pangkalan LPG 3 kg
              dalam jumlah banyak
            </h4>
            <p style={{ fontSize: '.75rem' }}>
              *Maksimal 1000 data pangkalan LPG 3 kg dan file berukuran 3MB
            </p>
            <br />
            <br />
          </div>
          <div className={styles['right-content-upload-reg']}>
            <img
              className={styles['illustration-upload']}
              src="assets/illu-registrasi-pangkalan.svg"
            />
          </div>
        </div>
        <ButtonFileInput
          clearErrors={clearErrors}
          deleteFile={handleRemoveFormData}
          errors={error.file}
          extensionAllowed={['xlsx']}
          handleChangeFile={handleChangeFile}
          name="file"
          noBase64={true}
          outlined={true}
          setError={setError}
          sizeValidation={{ kbsize: 3000000 }}
        >
          Pilih File
        </ButtonFileInput>
        <hr className={styles.separatorFormReg} />
        <div>
          <h5>Cara Tambah Sekaligus:</h5>
          <ol className={styles['step-upload-xlsx-regist-bulk']}>
            <li style={{ marginTop: '1rem' }}>
              Unduh contoh file Excel untuk registrasi pangkalan{' '}
              <a
                download
                href="https://storage.googleapis.com/fin-map-images-public-stage/templates/merchant-registration-template.xlsx"
                style={{ color: '#5E811E', cursor: 'pointer', fontWeight: 700 }}
              >
                di sini.
              </a>
            </li>
            <li style={{ marginTop: '1rem' }}>
              Isi data Pangkalan LPG 3 kg secara lengkap.
            </li>
            <li style={{ marginTop: '1rem' }}>
              {' '}
              Untuk panduan mengisi data agen dan data wilayah, silakan unduh
              file Excel{' '}
              <a
                download
                href="https://storage.googleapis.com/fin-map-images-public-stage/templates/map_references.xlsx"
                style={{ color: '#5E811E', cursor: 'pointer', fontWeight: 700 }}
              >
                di sini.
              </a>
            </li>
            <li style={{ marginTop: '1rem' }}>
              Unggah kembali{' '}
              <strong>file registrasi pangkalan di nomor 1</strong> yang sudah
              diisi, maksimal 1000 Pangkalan LPG 3 Kg dan maksimal file
              berukuran 3Mb
            </li>
          </ol>
        </div>
        <br />
        <div className={styles['action-btn-container']}>
          <ButtonLink
            className={styles['action-btn-back']}
            outlined={true}
            to={'/merchant/registrasi-pangkalan'}
          >
            Kembali
          </ButtonLink>
          <Button
            className={styles['action-btn-continue']}
            disabled={handleIsValid()}
            type="submit"
          >
            Unggah
          </Button>
        </div>
      </form>
    </>
  );
}

FormRegistrasiBulk.propTypes = {
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
};

export default reduxForm({
  form: 'bulk-registration',
  initialValues: {
    file: [],
  },
})(FormRegistrasiBulk);
